export class CollaboratorInfo {
  fullName: string;
  email: string;
  groupName: string;
}
